import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";
import {toast} from "react-toastify";
import {useTranslation} from "../../../hooks/useTranslation";

export default function CompanyBranchNewForm({handleClose, company_id, callback}) {
    const { t } = useTranslation();
    const token = useAuthStore((state) => state.token);

    const createCompanyBranch = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const result = PartnerApi.companyCompanyBranchAdd({
            token,
            company_id,
            data: {
                city: formData.get("city"),
                country: formData.get("country"),
                name: formData.get("name"),
                street: formData.get("street"),
                zip: formData.get("zip"),
            }
        });
        result.then((result) => {
            if ("error" in result) {
                toast.error(result.error);
                return;
            }

            handleClose();
            event.target.reset();
            if (callback) {
                callback();
            }
        });
        return false;
    }
    return (
        <form onSubmit={(e) => createCompanyBranch(e)}>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.name")}</label>
                <input name="name" className="form-control"/>
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.street")}</label>
                <input name="street" className="form-control"/>
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.city")}</label>
                <input name="city" className="form-control"/>
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.zip")}</label>
                <input name="zip" className="form-control"/>
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.country")}</label>
                <input name="country" className="form-control"/>
            </div>


            <button type="submit" className="btn btn-primary">{t("companyBranch.add")}</button>
        </form>
    );
}